module.exports = __webpack_public_path__ + "media/images/common/order_btn2_s_ov-d5387d103d54c5fec669ea4906186993.png";